<template>
  <v-container fluid class="pa-2">
    <template v-if="device">
      <v-row :class="['headline', 'ma-2']">
        <v-img max-width=24 src="/icon_cameras.png" />
        <span class="ml-4">{{device.name}}</span>
      </v-row>
      <v-row>
        <v-col cols=12>
        <v-tabs>
          <v-tab>Control</v-tab>
          <v-tab>Task</v-tab>
          <v-tab>Status</v-tab>
          <v-tab>Admin</v-tab>
          <v-tab-item>
            <DeviceTabControl :device="device"/>
          </v-tab-item>
          <v-tab-item>
            <DeviceTabTask :device="device"/>
          </v-tab-item>
          <v-tab-item>
            <DeviceTabStatus :device="device"/>
          </v-tab-item>
          <v-tab-item>
            <DeviceTabAdmin :device="device"/>
          </v-tab-item>
        </v-tabs>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import DeviceTabControl from '@/components/Device/DeviceTabControl.vue';
import DeviceTabTask from '@/components/Device/DeviceTabTask.vue';
import DeviceTabStatus from '@/components/Device/DeviceTabStatus.vue';
import DeviceTabAdmin from '@/components/Device/DeviceTabAdmin.vue';

const SUBSCRIPTION_DEVICE = gql`
subscription get_device($id: String!) {
  devices_by_pk(id: $id) {
    id
    name
    serial
    firmware
    code
    description
    mode
    timelapse_interval
    onsite_session_url
    location
  }
}
`;

export default {
  name: 'Device',
  data() {
    return {
      id: this.$route.params.id,
      device: null,
    };
  },
  components: {
    DeviceTabControl,
    DeviceTabTask,
    DeviceTabStatus,
    DeviceTabAdmin,
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    this.$store.commit('currentDeviceId', this.id);
  },
  watch: {
    '$route.params.id': (id) => {
      this.$store.commit('currentDeviceId', id);
    },
  },
  apollo: {
    $subscribe: {
      device: {
        query: SUBSCRIPTION_DEVICE,
        variables() {
          return {
            id: this.id,
          };
        },
        result(data) {
          this.device = data.data.devices_by_pk;
          this.$store.commit('currentDevice', this.device);
        },
      },
    },
  },
};
</script>
